<template>
  <div class="home-container">
    <!-- Hero Section -->
    <div class="hero-section">
      <presentacion />
    </div>

    <!-- About Section -->
    <section class="about-section">
      <div class="container">
        <h5 class="section-title">Acerca de CAPWASHMX</h5>
        <div class="">
          <p class="text-center">
            Servicios de Lavado, Planchado y Restaurado de Gorras en México
          </p>
        </div>
        <div class="content-wrapper">
          <!-- Logo Section -->
          <div class="logo-section">
            <div class="logo-container">
              <img src="../img/logo_v2.jpg" alt="Logo CAPWASHMX" class="logo-image" />
              <div class="logo-shadow"></div>
            </div>
          </div>

          <!-- Welcome Section -->
          <div class="text-section">
            <div class="welcome-card">
              <p class="welcome-text">
                ¡Bienvenido a CAPWASHMX, tu destino confiable para el cuidado completo de
                gorras en México! Nos enorgullece ofrecer una gama de servicios
                especializados que aseguran que tus gorras favoritas luzcan impecables y
                frescas en todo momento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <br>
    <!-- Services Section -->
    <section class="services-section">
      <div class="container">
        <h2 class="section-title">Nuestros Servicios</h2>
        
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">🧢</div>
            <h3 class="service-title">Lavado de Gorras</h3>
            <p class="service-description">
              Nuestro servicio de lavado utiliza técnicas avanzadas y productos de alta
              calidad para eliminar manchas, olores y restaurar la frescura original de
              tus gorras. Cuidamos cada detalle para preservar la forma y los colores,
              garantizando un resultado impecable.
            </p>
          </div>

          <div class="service-card">
            <div class="service-icon">♨️</div>
            <h3 class="service-title">Planchado</h3>
            <p class="service-description">
              En CAPWASHMX, entendemos la importancia de que tus gorras luzcan
              perfectamente planchadas. Nuestro servicio de planchado profesional
              utiliza técnicas especializadas para mantener la forma y suavidad de tus
              gorras, proporcionando un acabado impecable y pulcro.
            </p>
          </div>

          <div class="service-card">
            <div class="service-icon">⚙️</div>
            <h3 class="service-title">Restaurado con Máquina de Vapor</h3>
            <p class="service-description">
              Destacamos nuestro exclusivo servicio de restaurado de gorras con maquina
              de vapor. Este proceso delicado utiliza vapor de alta temperatura para
              eliminar arrugas, revitalizar tejidos y desinfectar, preservando la
              integridad de tus gorras sin comprometer la calidad.
            </p>
          </div>
        </div>

        <!-- Machine Image -->
        <div class="machine-section">
          <div class="machine-image-container">
            <img src="../img/maquina.jpeg" alt="Máquina de vapor CAPWASHMX" class="machine-image" />
            <div class="image-caption">Tecnología especializada para el cuidado de tus gorras</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Why Choose Us Section -->
    <section class="benefits-section">
      <div class="container">
        <h2 class="section-title">¿Por qué elegir CAPWASHMX?</h2>
        
        <div class="benefits-container">
          <div class="benefits-list">
            <div class="benefit-item">
              <div class="benefit-icon">✓</div>
              <div class="benefit-content">
                <h3 class="benefit-title">Experiencia</h3>
                <p class="benefit-description">
                  Contamos con un equipo capacitado en el cuidado especializado de gorras.
                </p>
              </div>
            </div>

            <div class="benefit-item">
              <div class="benefit-icon">⚡</div>
              <div class="benefit-content">
                <h3 class="benefit-title">Tecnología Avanzada</h3>
                <p class="benefit-description">
                  Utilizamos equipos modernos y métodos innovadores para garantizar
                  resultados de primera categoría.
                </p>
              </div>
            </div>

            <div class="benefit-item">
              <div class="benefit-icon">★</div>
              <div class="benefit-content">
                <h3 class="benefit-title">Compromiso con la Calidad</h3>
                <p class="benefit-description">
                  Nos esforzamos por superar tus expectativas, brindando servicios que
                  prolongan la vida útil y la apariencia de tus gorras.
                </p>
              </div>
            </div>
          </div>

          <div class="closing-card">
            <p class="closing-text">
              Confía en CAPWASHMX para mantener tus gorras en su mejor estado.
              <span class="highlight">¡Descubre la diferencia en cada detalle!</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import presentacion from "./presentacion.vue";
export default {
  components: { presentacion },
};
</script>

<style scoped>
/* Variables de color y tipografía */
:root {
  --primary-color: #2c3e50;
  --secondary-color: #3498db;
  --accent-color: #e74c3c;
  --light-color: #f9f9f9;
  --dark-color: #333;
  --shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  --border-radius: 10px;
  --transition: all 0.3s ease;
}

/* Estilos generales */
.home-container {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: var(--dark-color);
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  color: var(--primary-color);
  font-size: 2.2rem;
  margin-bottom: 2rem;
  position: relative;
  padding-bottom: 15px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: var(--secondary-color);
}

/* Hero Section */
.hero-section {
  margin-bottom: 3rem;
}

/* About Section */
.about-section {
  padding: 0px;
  background-color: var(--light-color);
}

.intro-box {
  background-color: var(--secondary-color);
  color: white;
  padding: 1.5rem;
  border-radius: var(--border-radius);
  text-align: center;
  margin-bottom: 2.5rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.intro-text {
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0;
  text-align: center;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

@media (min-width: 768px) {
  .content-wrapper {
    flex-direction: row;
    align-items: flex-start;
  }
}

.logo-section {
  flex: 1;
  display: flex;
  justify-content: center;
}

.logo-container {
  position: relative;
  max-width: 300px;
}

.logo-image {
  width: 100%;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  transition: var(--transition);
  z-index: 2;
  position: relative;
}

.logo-image:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.logo-shadow {
  position: absolute;
  bottom: -10px;
  left: 10%;
  width: 80%;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  filter: blur(8px);
  z-index: 1;
}

.text-section {
  flex: 1.5;
}

.welcome-card {
  background-color: white;
  padding: 2rem;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
}

.welcome-text {
  font-size: 1.1rem;
  text-align: justify;
  margin: 0;
}

/* Services Section */
.services-section {
  padding: 3rem 0;
  background-color: white;
}

.services-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-bottom: 3rem;
}

@media (min-width: 768px) {
  .services-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.service-card {
  background-color: var(--light-color);
  border-radius: var(--border-radius);
  padding: 2rem;
  box-shadow: var(--shadow);
  transition: var(--transition);
  border-top: 4px solid transparent;
}

.service-card:hover {
  transform: translateY(-5px);
  border-top-color: var(--secondary-color);
}

.service-card:nth-child(2):hover {
  border-top-color: var(--accent-color);
}

.service-card:nth-child(3):hover {
  border-top-color: #2ecc71;
}

.service-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.service-title {
  color: var(--primary-color);
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.service-description {
  text-align: justify;
  margin: 0;
}

.machine-section {
  margin-top: 2rem;
}

.machine-image-container {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.machine-image {
  width: 100%;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
}

.image-caption {
  font-style: italic;
  color: #666;
  margin-top: 10px;
  font-size: 0.9rem;
}

/* Benefits Section */
.benefits-section {
  padding: 3rem 0;
  background-color: var(--light-color);
}

.benefits-container {
  max-width: 900px;
  margin: 0 auto;
}

.benefits-list {
  margin-bottom: 2.5rem;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  background-color: white;
  padding: 1.5rem;
  border-radius: var(--border-radius);
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.3);
  transition: var(--transition); 
}

.benefit-item:hover {
  transform: translateX(5px);
}

.benefit-icon {
  font-size: 1.8rem;
  margin-right: 1.5rem;
  color: var(--secondary-color);
  flex-shrink: 0;
}

.benefit-content {
  flex: 1;
}

.benefit-title {
  color: var(--primary-color);
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
}

.benefit-description {
  margin: 0;
  text-align: left;
}

.closing-card {
  background-color: var(--primary-color);
  color: #333;
  padding: 2.5rem;
  border-radius: var(--border-radius);
  text-align: center;
  box-shadow: var(--shadow);
}

.closing-text {
  font-size: 1.2rem;
  margin: 0;
  line-height: 1.8;
}

.highlight {
  color:#e74c3c;
  font-weight: 700;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }
  
  .intro-text {
    font-size: 1.2rem;
  }
  
  .service-card {
    padding: 1.5rem;
  }
  
  .benefit-item {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .benefit-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }
}
</style>